import { FileResult, ServiceResult } from '../models';
import {
  RecipeCostingOptionDefaults,
  RecipeCostingRequest,
  RecipeDetailOptionDefaults,
  RecipeDetailRequest,
  RecipeMenuCostingOptionDefaults,
  RecipeMenuCostingRequest,
} from '../models/recipe-report.models';
import ApiService from './api-service';

class RecipeReportService extends ApiService {
  private static classInstance: RecipeReportService;

  private constructor() {
    super('RecipeReport');
  }

  public getRecipeCosting(request: RecipeCostingRequest): ServiceResult<FileResult> {
    return this.post(`${this.baseUrl}/GetRecipeCosting`, request);
  }

  public getRecipeCostingUserOptions(): ServiceResult<RecipeCostingOptionDefaults> {
    return this.get(`${this.baseUrl}/GetRecipeCostingUserOptions`);
  }

  public getRecipeMenuCosting(request: RecipeMenuCostingRequest): ServiceResult<FileResult> {
    return this.post(`${this.baseUrl}/GetRecipeMenuCosting`, request);
  }

  public getRecipeMenuCostingUserOptions(): ServiceResult<RecipeMenuCostingOptionDefaults> {
    return this.get(`${this.baseUrl}/GetRecipeMenuCostingUserOptions`);
  }

  public getRecipeDetailReport(request: RecipeDetailRequest): ServiceResult<FileResult> {
    return this.post(`${this.baseUrl}/GetRecipeDetailReport`, request);
  }

  public getRecipeDetailUserOptions(): ServiceResult<RecipeDetailOptionDefaults> {
    return this.get(`${this.baseUrl}/GetRecipeDetailReportUserOptions`);
  }

  public static getInstance(): RecipeReportService {
    if (!this.classInstance) {
      this.classInstance = new RecipeReportService();
    }
    return this.classInstance;
  }
}

export default RecipeReportService;
